import { CASES } from './constants';

export const updateProducts = (payload) => {
    return { type: CASES.UPDATE_PRODUCTS, payload };
};

export const updateProductsSearchForm = ({ key, data }) => {
    return {
        type: CASES.UPDATE_PRODUCTS_SEARCH_FORM,
        payload: { key, data },
    };
};

export const clearProducts = () => {
    return { type: CASES.CLEAR_PRODUCTS, payload: {} };
};
